import script from "./AnimationControlsV2.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimationControlsV2.vue?vue&type=script&setup=true&lang=js"

import "./AnimationControlsV2.vue?vue&type=style&index=0&id=65a0308c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65a0308c"]])

export default __exports__